<template>
    <div class="container">
        <v-dialog v-model="selectAccountDialog" max-width="400">
            <v-card class="ma-4" max-width="350" v-bind:key="account.id" v-for="account in selectAccountDialogEntries">
                <v-card-title class="text-wrap">
                    <p>{{account.name}}</p>
                </v-card-title>
                
                <v-card-subtitle>{{ `ΑΦΜ: ${account.tax_registration_number || '-'}` }}</v-card-subtitle>
                
                <v-card-text>
                    <v-container>
                        <v-row>
                            <div>{{account.city}} {{account.zipcode}}</div>
                        </v-row>
                        <v-row>
                            <div>{{account.address}}</div>
                        </v-row>
                        <v-row>
                            <div>{{account.telephone}}</div>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="updateAccount(selectAccountDialogShownFor, account); closeSelectAcountDialog();">ΕΠΙΛΟΓΗ</v-btn>
                </v-card-actions>
            </v-card>
        
        </v-dialog>

        <v-expansion-panels>
            <v-expansion-panel>
                <v-expansion-panel-header>
                    Φίλτρα αναζήτησης
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-menu
                                v-model="menu1"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="documentIssueDateStartFilter"
                                        label="Ημερομηνία έκδοσης (Από)"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="documentIssueDateStartFilter"
                                    @input="menu1 = false">
                                </v-date-picker>
                            </v-menu>
                        </v-col>

                        <v-col cols="12" sm="6">
                            <v-menu
                                v-model="menu2"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="auto">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="documentIssueDateStopFilter"
                                        label="Ημερομηνία έκδοσης (Έως)"
                                        append-icon="mdi-calendar"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                        clearable>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="documentIssueDateStopFilter"
                                    @input="menu2 = false">
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" sm="6">
                            <v-select 
                                v-bind:items="documentTypes" 
                                v-model="documentTypeFilter"
                                return-object
                                
                                item-text="description" 
                                label="Είδος παραστατικού"
                                clearable>
                            </v-select>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-text-field 
                                v-model="customer.name" 
                                label="Πελάτης"
                                append-icon="mdi-account-search"
                                @click:append="searchAccountByName('customer')"
                                v-bind:disabled="customerNotEditable">
                            </v-text-field>
                        </v-col>
                    </v-row>

                    <v-row class="my-2" cols="12" align="center" justify="center">
                        <v-btn 
                            class="mx-2"
                            color="success" 
                            @click="getData" 
                            v-bind:loading="getDataButtonDisabled"
                            style="width:120px;">
                            <span class="text-truncate" style="width:100px;">ΑΝΑΖΗΤΗΣΗ</span>
                        </v-btn>

                        <v-btn 
                            class="mx-2"
                            color="warning" 
                            @click="getExcel" 
                            v-bind:loading="getExcelButtonDisabled"
                            style="width:120px;">
                            <span class="text-truncate" style="width:100px;">ΕΞΑΓΩΓΗ</span>
                        </v-btn>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>

        </v-expansion-panels>

        
        <!-- <v-row class="my-2" cols="12" align="center" justify="center">
            <v-btn 
                class="mx-2"
                color="warning" 
                @click="getExcel" 
                v-bind:loading="getExcelButtonDisabled"
                style="width:120px;">
                <span class="text-truncate" style="width:100px;">ΕΞΑΓΩΓΗ</span>
            </v-btn>
        </v-row> -->
        
        <v-row class="my-2">
            <v-col cols="12">
                <v-data-table
                    :headers="headers"
                    :items="processedRows"
                    :sort-by="['issue_date']"
                    :sort-desc="true"
                    class="elevation-1 text-no-wrap"
                    disable-pagination
                    disable-filtering
                    hide-default-footer>
                </v-data-table>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    
export default {
    
    data() {
        return {
            // filters
            menu2: null,
            menu1: null,

            documentIssueDateStartFilter: null,
            documentIssueDateStopFilter: null,
            documentTypeFilter: null,
            customer: {},
            customerNotEditable: false,

            selectAccountDialog: false,
            selectAccountDialogEntries: [],
            selectAccountDialogShownFor: '',


            headers: [
                {
                    text: 'Ημ/νία Έκδοσης',
                    align: 'start',
                    value: 'Ημερομηνία',
                },
                {
                    text: 'Παραστατικό',
                    align: 'start',
                    value: 'customParastatiko'
                },
                {
                    text: 'Αρ. Παρ.',
                    align: 'start',
                    value: 'Αρ.Παραστατικού',
                },
                {
                    text: 'Πελάτης',
                    align: 'start',
                    value: 'customPelatis',
                },
                {
                    text: 'ΑΦΜ',
                    align: 'start',
                    value: 'Αφμ',
                },
                {
                    text: 'Χώρα',
                    align: 'start',
                    value: 'Χώρα',
                },
                {
                    text: 'Πόλη',
                    align: 'start',
                    value: 'Πόλη',
                },
                {
                    text: 'Καθαρό',
                    align: 'start',
                    value: 'Καθ.Αξία',
                },
                {
                    text: 'ΦΠΑ',
                    align: 'start',
                    value: 'Φ.Π.Α.',
                },
                {
                    text: 'Σύνολο',
                    align: 'start',
                    value: 'Σύνολο',
                },
                {
                    text: 'ΜΑΡΚ',
                    align: 'start',
                    value: 'Mark',
                },

            ],
            rows: [],
            documentTypes: [],

            getDataButtonDisabled: false,
            getExcelButtonDisabled: false,
        }
    },

    mounted() {
        axios.get('/api/document-types/balance')
        .then(response => this.documentTypes = response.data);

        this.initialize()
    },

    computed: {
        processedRows() {
            return this.rows.map(i => {
                return { 
                    ...i, 
                    customParastatiko: `${i['Παραστατικό']} ${i['Σειρά']}`,
                    customPelatis:  this.truncate(i['Πελάτης'], 25)
                }
            })
        }
    },

    methods: {

        

        initialize() {
            const initialDaysBeforeFilterValue = 30

            const today = new Date();

            let filterStart = new Date()
            filterStart.setDate(today.getDate() - initialDaysBeforeFilterValue);

            this.documentIssueDateStartFilter = this.$localYmd(filterStart)
            // this.documentIssueDateStopFilter = today.toISOString().split('T')[0]

            this.getData()
        },

        axiosDownload(url, params, filename) {
            this.getExcelButtonDisabled = true;

            console.log('btn disabled')
            
            axios({
                url: url, 
                params: params,
                method: 'GET',
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', filename); //or any other extension
                document.body.appendChild(link);
                link.click();
                this.getExcelButtonDisabled = false
            // link.remove();
            // url.remove();
            }).catch(err => { console.log(err); this.getExcelButtonDisabled = false})
        
                
        
      },

        getRequestParams() {
            return {
                issue_date_start: this.documentIssueDateStartFilter,
                issue_date_stop: this.documentIssueDateStopFilter,
                document_type_id: this.documentTypeFilter?.id ?? null,
                customer_id: this.customer?.id ?? null
            }

        },

        getData() {
            this.getDataButtonDisabled = true;
            axios.get(
                '/api/balance', 
                {
                    params: this.getRequestParams()
                }
            ).then(response => this.rows = response.data)
            .finally( () => this.getDataButtonDisabled = false)
        },

        getExcel() {
            this.axiosDownload('/api/balance/export', this.getRequestParams(), 'arxeio.xls')
        },

        truncate(s, n) {
            return s.substr(0, n-1) + ( s.length > n ? '...' : '');
        },

        async searchAccountByName(accountPropertyName) {
            let needle = this[accountPropertyName].name
            let response = await axios.get(`/api/accounts/search/name/${needle}`)

            if (response.data.length == 1)
                this.updateAccount(accountPropertyName, response.data[0])
            else if (response.data.length > 1) {

                this.selectAccountDialogEntries = response.data
                this.selectAccountDialogShownFor = accountPropertyName
                this.selectAccountDialog = true
            }
        },

        updateAccount(accountPropertyName, data) {
            this[accountPropertyName] = {
                id: data.id,
                address : data.address,
                name : data.name,
                city : data.city,
                telephone : data.telephone,
                fax : data.fax,
                email : data.email,
                country_id : data.country_id,
                mobile : data.mobile,
                tax_registration_number: data.tax_registration_number,
                zipcode: data.zipcode,
                tax_registration_office_id: data.tax_registration_office_id,
                jobtitle: data.jobtitle
            }
        },
        
        closeSelectAcountDialog() {
            this.selectAccountDialog = false
            this.selectAccountDialogEntries = []
            this.selectAccountDialogShownFor = null
        },


    }
}
</script>